/**
 * ManualPlayerBadge Container Component
 *
 * Conditionally renders a badge for players that were manually created
 * by organization users via the "Manually Add Player" modal.
 * Returns null when the player is not manual, avoiding unnecessary renders.
 * @module components/ManualPlayerBadge
 */
import React from "react";

import ManualPlayerBadgeView from "./ManualPlayerBadgeView";

/**
 * Props for ManualPlayerBadgeContainer
 */
interface ManualPlayerBadgeContainerProps {
  readonly show: boolean;
  readonly compact?: boolean;
}

/**
 * Container that gates rendering of the manual player badge
 * @param root0 - Component props
 * @param root0.show - Whether to display the badge (returns null if false)
 * @param root0.compact - When true, renders shorter "MANUAL" text for compact list views
 */
const ManualPlayerBadgeContainer = ({
  show,
  compact = false,
}: ManualPlayerBadgeContainerProps) => {
  if (!show) {
    return null;
  }

  return <ManualPlayerBadgeView compact={compact} />;
};

export default React.memo(ManualPlayerBadgeContainer);
